import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { Dialog, DialogContent, DialogTitle, FormControl, Box, TextField, IconButton, DialogActions, Divider} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { setMeetingTrack } from "../../redux/actions/leadSourceActions";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { useDispatch } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { EyeFilled } from '@ant-design/icons';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    tableHeaderCell: {
        backgroundColor: '#f0f8ff',
        fontWeight: 'bold',
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#83A2CD",
        color: "black",
        fontWeight: "500",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const MeetingTrackerDashboard = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const meetingData = useSelector((state) => state.leadSource.meetingTracker);
    const [store, setStore] = useState([]);
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [notesVisibility, setNotesVisibility] = useState(false)
    const [latestNotes, setLatestNotes] = useState([])
    const [leadNo, setLeadNo] = useState("");
    const [showMeetingLogs, SetShowMeetingLogs] = useState(false);
    const [meetingLogs, setMeetingLogs] = useState([]);
    const [clickBasedlog, SetClickBasedLog] = useState();
    const [isSpinning, setIsSpinning] = useState(false);
    const FORTH_BUTTON_DISABLE_UNTIL_KEY = 'forthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [shouldRefresh, setShouldRefresh] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
   

    useEffect(() => {
        if ((userDetails.roles.find(role => role.name === ROLENAME.AssistantSalesManager))) {
            meetingTrackerData()
            setSelectedRole(ROLENAME.AssistantSalesManager)
        } else if ((userDetails.roles.find(role => role.name === ROLENAME.SalesUser))) {
            meetingTrackerData()
            setSelectedRole(ROLENAME.SalesUser)
        } else {
            meetingTrackerData()
            setSelectedRole("ALL")
        }
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadWonDate", label: "Sales Won Date" },
        { key: "meetingType", label: "Meeting Type" },
        { key: "meetingDateTime", label: "Meeting Date" },
        { key: "leadCreatedDate", label: "Lead Created Date" },
        { key: "salesExecutive", label: "Sales Executive" },
        { key: "asm", label: "ASM" },
        { key: "meetingLog", label: "Meeting Log" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.leadId?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.leadId?.lead_no || "N/A",
                    clientName: popMonthData[i]?.leadId?.customerId?.name,
                    totalValue: popMonthData[i]?.staticSalesWonBudget || 0,
                    expCtrName: popMonthData[i]?.experienceCenterId?.name,
                    currentStage: popMonthData[i]?.leadId?.currentStage ? popMonthData[i]?.leadId?.currentStage : 'NA',
                    leadWonDate: popMonthData[i]?.leadId?.leadWonDate ? moment(popMonthData[i]?.leadId?.leadWonDate).format("DD-MM-YYYY"): 'NA',
                    meetingType: popMonthData[i]?.meetingType || "NA",
                    meetingDateTime: moment(popMonthData[i]?.meetingDate).format('DD-MM-YYYY') || "NA",
                    leadCreatedDate: moment(popMonthData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
                    salesExecutive: popMonthData[i]?.leadId?.salesUser?.name || "NA",
                    asm: popMonthData[i]?.leadId?.salesAssistantManager?.name || "NA",
                    meetingLog: popMonthData[i]?.meetingLogsCount || "NA",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     currentStage: "",
                //     salesWonDate: "",
                //     meetingType: "",
                //     meetingDateTime: "",
                //     leadCreatedDate: "",
                //     salesExecutive: "",
                //     asm: ""
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const meetingTrackerData = async (addExpCenter, usersData, selectedSearchType, searchInput) => {
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            lost: selectLost !== "" ? selectLost : "",
            pivotValue: 'meetingTracker',
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.AssistantSalesManager)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.AssistantSalesManager
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            if( !meetingData  ||  meetingData === null){
            let response = await HttpService.getMeetingTrackerBasedOnUserExpCenter(obj);
            setStore(response.data);
            dispatch(setMeetingTrack(response.data));
            }else{
                setStore(meetingData)
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        props.setLoading(false);
    }


    const formatNumberToTwoDecimalPlaces = (value) => {
        return Math.floor(parseFloat(value));
    };
    

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        meetingTrackerData(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    }
    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }
    const handleSearch = async (value) => {
        meetingTrackerData(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };
    

    const getDataBasedOnClickMeetingTracker = async (e, month, innerEl, val, particularName) => {
        let obj = {}
        let users = ''
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        if (val === 'meetingTracker') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                lost: selectLost !== "" ? selectLost : "",
                pivotValue: 'meetingTracker',
                selectedRole: selectedRole ? selectedRole : "",
                userExpCenter: userDetails.experienceCenterId,
                users: users ? users : "",
                particularName: particularName,
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : ""
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    startDate: storeDateFilter?.startDate,
                    endDate: storeDateFilter?.endDate,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'meetingTracker',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    users: users ? users : "",
                    particularName: particularName,
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
            } else {
                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenter,
                    startDate: storeDateFilter?.startDate,
                    endDate: storeDateFilter?.endDate,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'meetingTracker',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    users: users ? users : "",
                    particularName: particularName,
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
            }
        }
        props.setLoading(true);
        try {
            SetClickBasedLog(obj)
            let response = await HttpService.getDataBasedClickMeetingTracker(obj);
            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleViewNotes = (notes, lead_no) => {
        setNotesVisibility(true)
        setLatestNotes(notes)
        setLeadNo(lead_no)
    }

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        dispatch(setMeetingTrack(null))
        setShouldRefresh(true) // Trigger the useEffect
        meetingTrackerData(selectedExperienceCenter, selectedUsers, "", "")
    }

    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
        
        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);
            
            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
            const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
            setTimeLeft(remainingTimeInSeconds);
            setIsDisabled(true);
            } else {
            // If the time has passed, clear localStorage
            localStorage.removeItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
            setIsDisabled(false);
            setTimeLeft(0);
            }
        }
        
        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
            setTimeLeft(prevTime => {
                const newTime = prevTime - 1;
                if (newTime <= 0) {
                // When time is up, clear localStorage and enable button
                localStorage.removeItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                return 0;
                }
                return newTime;
            });
            }, 1000);
        }
        
        return () => clearInterval(timer);
        }, [isDisabled, timeLeft]);
    
        useEffect(() => {
            if (shouldRefresh && meetingData === null) {
                meetingTrackerData(selectedExperienceCenter, selectedUsers, "", "")
                setShouldRefresh(false)
            }
        }, [meetingData, shouldRefresh])
    
        // Format time for display
        const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        };
    
        // Replace your existing handleRefreshClick with this
        const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
        
        // Store the timestamp in localStorage
        localStorage.setItem(FORTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
        
        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(10); // 4 minutes in seconds
        
        // Run the original functionality
        setIsSpinning(true);
        clearDateFilter();
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
        };
    
    const handleOpenViewMeetingsLogs = async (leadId) => {
        SetShowMeetingLogs(true);
        try {
            const response = await HttpService.getDataForMeetingTracket(leadId?.leadId?._id);
            const data = response?.data;
    
            if (data?.success) {
                const targetMonth = clickBasedlog?._id?.startMonth;
                const targetYear = clickBasedlog?._id?.startYear;
                // Extract start and end dates for the range from clicked data
                const startDate = new Date(clickBasedlog?.startDate || "2000-01-01");
                const endDate = new Date(clickBasedlog?.endDate || "2100-12-31"); 

                // Also, get start and end years from the clicked data
                const startYear = clickBasedlog?._id?.startYear;
                const endYear = clickBasedlog?._id?.endtYear;

                const targetMonthSingle = clickBasedlog?._id?.month;
                const targetYearSingle = clickBasedlog?._id?.year;
    
                // Filter meetings based on particularName and date
                // if(targetMonth && targetYear && startYear && endYear) {
                    const filteredMeetings = data?.meetingLogs?.filter(meeting => {
                        const meetingDate = new Date(meeting?.meetingDate);
                        const meetingMonth = meetingDate?.getMonth() + 1; // 0-indexed, so add 1
                        const meetingYear = meetingDate?.getFullYear();
        
                        // Check if the meeting is in the target month/year
                        const isTargetMonthYear = meetingMonth === targetMonth && meetingYear === targetYear;
                        const isWithinRange = meetingDate >= startDate && meetingDate <= endDate;
                        const isWithinYearRange = meetingYear >= startYear && meetingYear <= endYear;
        
                        switch (clickBasedlog?.particularName) {
                            case "NoOfMeeting":
                                return (isTargetMonthYear || isWithinRange || isWithinYearRange);
        
                            case "WonFromMeeting":
                                return (isTargetMonthYear || isWithinRange || isWithinYearRange);

                            case "NotWonNotLost":
                                return (isTargetMonthYear || isWithinRange || isWithinYearRange);

                            default:
                                return false;
                        }
                    });  
                    setMeetingLogs(filteredMeetings);
                // } else {
                //     const filteredMeetings = data?.meetingLogs?.filter(meeting => {
                //         const meetingDate = new Date(meeting?.meetingDate);
                //         const isTargetMonth = meetingDate?.getMonth() + 1 === targetMonthSingle && 
                //                 meetingDate?.getFullYear() === targetYearSingle;
                        
                //         switch (clickBasedlog?.particularName) {
                //             case "NoOfMeeting":
                //                 return isTargetMonth;
                                
                //             case "WonFromMeeting":
                //                 return isTargetMonth;

                                
                //             case "NotWonNotLost":
                //                 return isTargetMonth;

                //             default:
                //                 return false;
                //         }
                //     });
                //     setMeetingLogs(filteredMeetings);
                // }
            }
        } catch (error) {
            console.error("error", error);
        }
    };

    const handleCloseViewMeetingsLogs = () => {
        SetShowMeetingLogs(false)
    }

    return (
        <div className="App">
            <br />
            <div>
                <Paper className={classes.paper}>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="Meeting Done From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="Meeting Done End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    onClick={handlePivotDateFilter} 
                                    style={{ 
                                        backgroundColor: "#F50057", 
                                        color: "#fff", 
                                        padding: "0.4rem 2rem" 
                                    }} 
                                    className={classes.submitButton}
                                >
                                    Submit
                                </Button>
                                <Button
                                    onClick={handleRefreshClick}
                                    variant="contained"
                                    disabled={isDisabled}
                                    style={{ 
                                        backgroundColor: isDisabled ? "#cccccc" : "#F47E46", 
                                        color: "#FFF2EB",
                                        padding: "0.4rem 2rem"
                                    }}
                                >
                                    {isDisabled 
                                        ? `Wait (${formatTimeLeft()})` 
                                        : "Fetch New Data"}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
                    <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold'}}> Months </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold'}}> Particulars </StyledTableCell>
                                        {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{
                                                    fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                                    fontWeight:'bolder',
                                                    textAlign: 'center',
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, 
                                                }}
                                            >
                                                <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                    <span style={{ cursor: "pointer" }}>
                                                        {experienceCenterName.expCenterCode}
                                                    </span>
                                                </Tooltip>
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", fontWeight: 'bold' , background: '#83A2CD'}}>
                                           Total
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                            {/* Table Body */}
                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                        <React.Fragment key={monthIndex}>
                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 'bold' }}
                                                    rowSpan={3}
                                                >
                                                    {`${month?.monthName?.slice(0, 3)}-${month?.year % 100}`}
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", background: 'white'}}
                                                >
                                                    Total No. of Leads with Meeting
                                                </StyledTableCell>

                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <React.Fragment key={expCenterIndex}>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    background: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? '#83A2CD' : 'white',
                                                                    textDecoration:'underline',
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, month, innerEl, 'meetingTracker','NoOfMeeting')}
                                                            >
                                                                {formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.meetingCount || 0
                                                                )}
                                                            </StyledTableCell>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", background:'white'}}
                                                >
                                                    Total No. of Leads with Won Meeting
                                                </StyledTableCell>
                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <React.Fragment key={expCenterIndex}>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    textDecoration:'underline',
                                                                    background: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? '#83A2CD' : 'white',
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, month, innerEl, 'meetingTracker', 'WonFromMeeting')}
                                                            >
                                                                {formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.wonMeetingCount || 0
                                                                )}
                                                            </StyledTableCell>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", background:'white' }}
                                                >
                                                   Total No. of Leads with Neither Won Nor Lost Meeting
                                                </StyledTableCell>
                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <React.Fragment key={expCenterIndex}>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    textDecoration:'underline',
                                                                    background: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? '#83A2CD' : 'white',
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, month, innerEl, 'meetingTracker', 'NotWonNotLost')}
                                                            >
                                                                {formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.notWonNotLostMeetingCount || 0
                                                                )}
                                                            </StyledTableCell>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>
                                        </React.Fragment>
                                    ))}

                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold' }}
                                            rowSpan={3}
                                        >
                                            Grand Total
                                        </StyledTableCell>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", background: '#83A2CD'}}
                                        >
                                            Total No. of Leads with Meeting
                                        </StyledTableCell>

                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#83A2CD" }}
                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, store[0].monthlyGrandTotal, experienceCenterName, 'total', 'NoOfMeeting')}
                                            >
                                                {formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.meetingCount : 0), 0))}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                    {/* 2nd  */}
                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}
                                        >
                                            Total No. of Leads with Won Meeting
                                        </StyledTableCell>

                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#83A2CD" }}
                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, store[0].monthlyGrandTotal, experienceCenterName, 'total', 'WonFromMeeting')}
                                            >
                                                {formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.wonMeetingCount : 0), 0))}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                    {/* 3rd */}
                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}
                                        >
                                           Total No. of Leads with Neither Won Nor Lost Meetings
                                        </StyledTableCell>

                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#83A2CD" }}
                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, store[0].monthlyGrandTotal, experienceCenterName, 'total', 'NotWonNotLost')}
                                            >
                                                {formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.notWonNotLostMeetingCount : 0), 0))}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>
            <Modal
                title='Meeting Tracker'
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename='meetingTracker.csv'
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 500 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Meeting Date</StyledTableCell>
                                    <StyledTableCell>Lead Created Date</StyledTableCell>
                                    <StyledTableCell>Sales Executive</StyledTableCell>
                                    <StyledTableCell>ASM</StyledTableCell>
                                    <StyledTableCell>Latest Notes</StyledTableCell>
                                    <StyledTableCell>Meeting Logs</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {
                                                    data?.leadId?.erpProjectNo ? <Link to={`/project-logs/${data?.leadId?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.leadId?.erpProjectNo}</Link> :'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }} >
                                                {
                                                    data?.leadId?.lead_no ? <Link to={`/project-logs/${data?.leadId?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.leadId?.lead_no}</Link> : 'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.leadId?.customerId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}> {data?.experienceCenterId?.name} </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadId?.currentStage? data?.leadId?.currentStage : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadId?.leadWonDate ? moment(data?.leadId?.leadWonDate).format("DD-MM-YYYY"): "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                            { moment(data?.meetingDate).format('DD-MM-YYYY')}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                            { moment(data?.leadId?.createdAt).format('DD-MM-YYYY')}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadId?.salesUser ? data?.leadId?.salesUser?.name : 'NA'}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                {data?.leadId?.salesAssistantManager ? data?.leadId?.salesAssistantManager?.name : 'NA'}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                <EyeFilled
                                                    style={{ cursor: 'pointer', fontSize: '20px', color: '#1890ff' }}
                                                    onClick={() => handleViewNotes(data?.recentNotes, data?.leadId?.lead_no)}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                <span onClick={() => handleOpenViewMeetingsLogs(data)} style={{ color: "#000", textDecoration: 'underline', textAlign: 'center', cursor: "pointer", }}>
                                                    {data?.meetingLogsCount ? data?.meetingLogsCount : 'NA'}
                                                </span>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
             <div>
                <Dialog
                    open={notesVisibility}
                    onClose={() => setNotesVisibility(false)}
                >
                    <DialogTitle>
                        {`Notes of the lead no - ${leadNo || "NA"}`}
                        <IconButton
                            aria-label="close"
                            onClick={() => setNotesVisibility(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {latestNotes && latestNotes.length > 0 ? (
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHeaderCell}><b>Sl. No</b></TableCell>
                                            <TableCell className={classes.tableHeaderCell}><b>Notes</b></TableCell>
                                            <TableCell className={classes.tableHeaderCell}><b>Created At</b></TableCell>
                                            <TableCell className={classes.tableHeaderCell}><b>User</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {latestNotes.map((note, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{note?.notes}</TableCell>
                                                <TableCell>{moment(note?.createdAt).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell>{note?.user?.name || "NA"}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <p>No notes available.</p>
                        )}
                    </DialogContent>
                </Dialog>
            </div> 

           {/* Meeting Logs display */}
            <div>
                <Dialog  maxWidth="md" fullWidth open={showMeetingLogs} onClose={handleCloseViewMeetingsLogs} >
                    <DialogTitle style={{ textAlign: "left", }} >Meeting Logs</DialogTitle>
                    <DialogContent>
                        <Box>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Sl.No</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Created Date</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Stage</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Meeting Date</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Meeting Type</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {meetingLogs?.map((log, index) => (
                                            <TableRow key={index}>
                                                <TableCell  component="th">{index + 1}</TableCell>
                                                <TableCell  component="th">
                                                    {new Date(log?.createdAt).toLocaleDateString()}
                                                </TableCell>
                                                <TableCell component="th">
                                                    {log?.meetingStage || 'Designer Assignment Pending'}
                                                </TableCell>
                                                <TableCell component="th">
                                                    {log?.meetingDate ?
                                                        new Date(new Date(log?.meetingDate).getTime() + (5 * 60 + 30) * 60 * 1000).toLocaleDateString()
                                                        : '-'}
                                                </TableCell>

                                                <TableCell component="th">
                                                    {log?.meetingTypes?.officeMeets?.length > 0 ? 'Office Meet' :
                                                        log?.meetingTypes?.residenceMeets?.length > 0 ? 'Residence Meet' : ''}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {meetingLogs?.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={4} align="center">
                                                    No meetings found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseViewMeetingsLogs}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(MeetingTrackerDashboard);